export const routesMenu = [
  {
    path: '/menu',
    name: 'menu-list',
    component: () => import('@/views/menu/list/index.vue'),
    meta: {
      pageTitle: 'menu.Menü Yönetimi',
      breadcrumb: [
        {
          text: 'Menü',
          active: true,
        },
      ],
      yetki: { k: [], p: true },
    },
  },
]
